import { render, staticRenderFns } from "./ReRegisterPassword.vue?vue&type=template&id=7873c41e&"
import script from "./ReRegisterPassword.vue?vue&type=script&lang=js&"
export * from "./ReRegisterPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports